import '../css/sumTable.css';

export interface ISumTableProps {
  unit: string;
  labels: string[];
  values: number[][];
  backgrounds: string[];
  isSelect: boolean[];
  exist: boolean[];
}

export const SumTable = (props: ISumTableProps) => {
  if (
    props.labels.length !== props.values.length ||
    props.backgrounds.length !== props.labels.length ||
    props.isSelect.length !== props.labels.length ||
    props.exist.length !== props.labels.length
  ) {
    console.warn('データ不整合が検出されました');
    return <></>;
  }
  return (
    <table className="SumTable">
      <colgroup>
        <col style={{ width: '50%' }} />
        <col style={{ width: '50%' }} />
      </colgroup>
      <thead>
        <tr className="SumTableColumnHeader">
          <th scope="col">項目</th>
          <th scope="col">合計[{props.unit}]</th>
        </tr>
      </thead>
      <tbody>
        {props.labels.map((_, index) => {
          if (props.exist[index]) {
            if (props.isSelect[index]) {
              return (
                <tr>
                  <th style={{ background: props.backgrounds[index] }}>{props.labels[index]}</th>
                  <td>{props.values[index].reduce((acc, cur) => acc + cur, 0).toLocaleString()}</td>
                </tr>
              );
            }
          }
          return <></>;
        })}
      </tbody>
    </table>
  );
};
